import Forbiden from './Forbiden'

export default Forbiden